import React from 'react';
import { withRouter } from 'react-router-dom';
import LayoutManager from 'erpcore/utils/LayoutManager';
import Notification from 'erpcore/components/Notification';
import PageNotifications from 'erpcore/components/Layout/PageNotifications';

import PageHeader from 'erpcore/components/Layout/PageHeader';
import Button from 'erpcore/components/Button';

const ResetPasswordSignedIn = () => {
    return (
        <LayoutManager slot="main" className="main--narrow" layoutType="merge">
            <PageHeader title="You are already signed in!" />

            <PageNotifications />

            <Notification
                title=""
                text="You are already signed in. Please go to My account to change your password."
                type="warning"
            >
                <Button href="/my-account" label="Go to My account" />
            </Notification>
        </LayoutManager>
    );
};

ResetPasswordSignedIn.defaultProps = {};

ResetPasswordSignedIn.propTypes = {};

export default withRouter(ResetPasswordSignedIn);
